import { get as _get } from 'lodash'
import Color from 'color';
import fetch from '@/api/fetch.js'
import { APP_CHANNEL } from '@/common/utils/variables.js'
import { get2025ThemeList } from '@/config/theme.js'

const _fetch = (config = {}) => {
  return fetch({
    ...config,
  }).then(response => {
    const { data, success, code, info } = response.data;
    if (!success) {
      return Promise.reject(new Error(`${code}: ${info}`));
    }
    return data
  })
}

export function getThemeList() {
  // return Promise.resolve(get2025ThemeList())
  return _fetch({
    url: '/planBook/insurance/compare/getSkinListByUserId'
  }).then(data => {
    let skinList = _get(data, 'skinList') || []
    if (APP_CHANNEL === 'NUOYA') {
      skinList = skinList.filter(e => e.key === 'theme_nuoya_default')
    } else {
      skinList = skinList.filter(e => e.key !== 'theme_nuoya_default')
    }
    const themeList = []
    skinList.forEach(e => {
      const item = {
        id: e.id,
        key: e.key,
        name: e.skinName,
        skinType: e.skinType,
        collect: e.collect,
        sort: e.sort,
        bannerImage: e.headerImageUrl,
        bannerNameBg: e.nameBackgroundColor,
        themePrimaryColor: e.titleColor,
        themePrimaryBg: e.mainBlockColor,
        themeMinorBg: e.markColor,
        themePathBg: e.titleColor ? Color(e.titleColor).mix(Color('white'), 0.9).hex() : e.titleColor,
        themeBorderColor: e.titleColor ? Color(e.titleColor).mix(Color('white'), 0.7).hex() : e.titleColor,
      }
      themeList.push(item)
    })
    return themeList
  })
}

export function saveSkinCollect(params) {
  return _fetch({
    url: '/planBook/insurance/compare/skin/collect',
    params
  })
}
